import React from 'react';
import BLComponent from '../../core/_BLComponent.jsx';
import MyCollectionProtocol	from '../controller/MyCollectionProtocol.js';
import ErrorModal			from './_ErrorModal.jsx';
import Pagination 			from '../../common/_Pagination.jsx';
import GridView				from './_GridView.jsx';
import ListView				from './_ListView.jsx';
import { ItemDetailInfo, CategoryUtil, ItemListUtil } from '../controller/MyCollectionUtils.js';


export default class ItemView extends BLComponent {
    constructor(props, context) {
        super(props, context);	// This should come first. 
		this.state = {
			listItem:this.props.data.listItem
            ,	curPage: 0
            ,	listingOptions:{}
		,	showChkQtyErrorModal: false
		}
    }

    componentDidMount() {
        const {itemPage, listingOptions} = this.props.data;
		//this.setState({curPage: itemPage, listingOptions: listingOptions });		
		this.setState({curPage: itemPage, listingOptions: listingOptions }, this.loadListData(itemPage, false));		
    }

    componentWillUnmount() 
	{
		this.setState = (state,callback)=>{
        	return;
    	};
	}

    loadListData(page, forceReload)
	{
		if (forceReload) 
			this.props.func.getListItem(page);
		else
			if (this.state.listItem.length == 0) this.props.func.getListItem(page);
		
		this.props.func.reloadTriggerOff();
	}

	render()
	{
		const listItem = this.state.listItem;
		const {listingOptions, nLotCnt, dispItemType, showCategoryTree, strSearchKeyword} = this.props.data;
		const {myCollectionConfig, itemPage} = this.props.data;
		const cntUpdatedQty = this.getItemCntUpdatedQty();
		const isEmpty = ItemListUtil.isEmptyList(listItem)
		const bShowCategoryTree = (isEmpty)?false:showCategoryTree;

		const listView = ()=>{
			if (listingOptions.strListViewType == "G")
			{
				return (
					<GridView 
						data={{
							myCollectionConfig: myCollectionConfig,
							dispItemType: dispItemType, 
							listItem:listItem, 
							listingOptions:listingOptions, 
							showCategoryTree: bShowCategoryTree,
							strSearchKeyword: strSearchKeyword
						}}  
						func={{
							updateItemQty:(idx,qty)=>this.updateItemQty(idx,qty), 
							saveInvChanges:()=>this.saveInvChanges(), 
							getGenInvInfo:()=>this.props.func.getGenInvInfo(), 
							markAsDeletion:(idx, mark)=>this.markAsDeletion(idx, mark),
							enableEditNote: (idx)=>this.enableEditNote(idx),
							updateNoteContent: (idx, note)=>this.updateNoteContent(idx, note)
						}}
					/>
				)
			}
			else
			{
				return (
					<ListView 
						key={listItem + showCategoryTree}
						data={{
							myCollectionConfig: myCollectionConfig,
							dispItemType: dispItemType, 
							listItem:listItem, 
							listingOptions:listingOptions, 
							showCategoryTree: bShowCategoryTree,
							strSearchKeyword: strSearchKeyword
						}}  
						func={{
							updateItemQty:(idx,qty)=>this.updateItemQty(idx,qty), 
							saveInvChanges:()=>this.saveInvChanges(), 
							getGenInvInfo:()=>this.props.func.getGenInvInfo(), 
							markAsDeletion:(idx, mark)=>this.markAsDeletion(idx, mark), 
							updateSortType: (sortType)=>this.props.func.updateSortType(sortType), 
							updateSortOrder: ()=>this.props.func.updateSortOrder(),
							enableEditNote: (idx)=>this.enableEditNote(idx),
							updateNoteContent: (idx, note)=>this.updateNoteContent(idx, note)
						}}
					/>
				)
			}
		}
		const paginationData = {postsPerPage: listingOptions.nListSize, currentPage: itemPage, totalItemCnt: nLotCnt, changePageCallback: ( p ) => this.jumpPage( p ) };
		return(
			<React.Fragment>
				{ ( cntUpdatedQty > 0)&&
				<div className="personal-inventory__sticky-bar-bottom ">
					<div className="personal-inventory__container-full-width l-margin-x--auto l-margin-bottom">
						<div className="l-flex l-column l-end">
							<div className="l-flex">
								<button id="MPI-discardChanges-btn" className="btn btn--white btn--tight l-margin-right--xl" onClick={()=>this.discardItemUpdates()}>Discard changes</button>
								<button id="MPI-saveChanges-btn" className="btn btn--cta btn--tight" onClick={()=>this.saveInvChanges()}>Save {cntUpdatedQty} change{(cntUpdatedQty>1)?"s":""}</button>
							</div>
						</div>
					</div>
				</div>
				}
				<div className={ (paginationData.totalItemCnt > paginationData.postsPerPage)?"l-margin-bottom--xl":"" }>
					{listView()}
				</div>
				<Pagination  data={paginationData}>
						{[]}
				</Pagination>
				{(this.state.showChkQtyErrorModal)&&this.renderShowQtyErrorModal()}
			</React.Fragment>
		)
	}

	renderShowQtyErrorModal() {
		return (
			<ErrorModal data={{errorType: "updateQtyError", itemType:"P"}} func={{toggleUpdateErrorModal:()=>this.toggleUpdateErrorModal()}}/>
		)
	}

	toggleUpdateErrorModal() {
		this.setState({showChkQtyErrorModal:false});
	}

	discardItemUpdates() {
		let listItem = this.state.listItem;
		for( const item of listItem ) {
			if (typeof item.newQty != "undefined" ) item.newQty = item.invQty;
			if (item.markedAsDeletion) item.markedAsDeletion = false;
			if (typeof item.newNote != "undefined" ) {
				item.newNote = item.note;
			}
			item.editNote = false;

		}
		this.setState({listItem:listItem});
		this.props.func.discardItemUpdates();
	}

	completeUpdate() {
		let listItem = this.state.listItem;
		for( const item of listItem ) {
			if (typeof item.newQty != "undefined" ) item.invQty = item.newQty;
			item.editNote = false;
		}
		this.setState({listItem:listItem});
		this.props.func.getGenInvInfo();
		this.props.func.reloadTriggerOn();
	}

	saveInvChanges() {
		this.reqUpdateInv();
	}

	getItemCntUpdatedQty() {
		const listItem = this.state.listItem;
		let cnt = 0;
		for( const item of listItem ) {
			const {bNoteUpdated, bQtyUpdated} = ItemDetailInfo.getInfo(item);
			if ( bNoteUpdated || bQtyUpdated ) {
				cnt++;
			} else {
				if (item.markedAsDeletion) cnt++;
			}
		}

		return cnt;
	}

	markAsDeletion(idx, mark) {
		let listItem = this.state.listItem;
		listItem[idx].markedAsDeletion = mark;
		this.setState({listItem:listItem});
		this.props.func.markAsDeletion(idx, mark);
	}

	enableEditNote(idx) {
		let listItem = this.state.listItem;
		listItem[idx].editNote = !listItem[idx].editNote;
		this.setState({listItem:listItem});
		this.props.func.enableEditNote(idx);

	}

	updateNoteContent(idx, note) {
		let listItem = this.state.listItem;
		listItem[idx].newNote = note;
		this.setState({listItem:listItem});
		this.props.func.updateNoteContent(idx, note);
	}


	updateItemQty(idx, qty) {
		let listItem = this.state.listItem;
		let item = listItem[idx];
		const invId = item.invId;
		let newQty = 0;
		if (parseInt(qty) >= 0) {
			newQty = qty;
			listItem[idx].newQty = newQty;
		}
		else
		{
			listItem[idx].newQty = "";
		}

		this.setState({listItem:listItem});
		this.props.func.updateItemQty(idx, qty);
	}

	

	jumpPage(page)
	{
		this.setState({curPage:parseInt(page)}, this.loadListData(page, true));
		this.props.func.updateItemPage("P", parseInt(page));
	}

	chkQtyValueErr() {
		let listItem = this.state.listItem;
		for( const item of listItem ) {
			if ( (typeof item.newQty != "undefined") && (item.newQty.toString().length > 6) ) return true;
			
			let bQtyUpdated = (typeof item.newQty == "undefined")?false:(item.newQty != item.invQty)?true:false;
			if ((typeof item.newQty != "undefined") && (item.newQty == "")) return true;
		}
		return false;
	}

	reqUpdateInv() {
		const {dispItemType} = this.props.data;
		const listItem = this.state.listItem;
		let listUpdateQty = [];
		let deleteAll = true;

		if (this.chkQtyValueErr()) {
			this.setState({showChkQtyErrorModal:true});
			return null;
		}
		for( const item of listItem ) {
			const {bNoteUpdated, bQtyUpdated, newNote, qty} = ItemDetailInfo.getInfo(item);
			
			if ( bNoteUpdated || bQtyUpdated ) {
				listUpdateQty[listUpdateQty.length] = {personalInventoryID:item.invId, qty:qty, itemNote:newNote}
				if (qty > 0) deleteAll = false;
			}
			else if (item.markedAsDeletion) {
				listUpdateQty[listUpdateQty.length] = {personalInventoryID:item.invId, qty:0}
			}
			else {
				deleteAll = false;
			}
		}
		
		if (deleteAll) {
			const listCategory = CategoryUtil.getSelectedCategory(dispItemType);			
			CategoryUtil.clearCategoryFilter( dispItemType );
		}
			
		MyCollectionProtocol.reqUpdateInvQty(
			listUpdateQty
		).then(
		   	( data ) =>
		   	{
		   		this.completeUpdate();
		    }
		).catch(
			( err ) =>
			{
				console.log( err );
			}
		);
		
		
	}

	getItemNote(item) {
		let itemNote = (typeof item.note == "undefined")?"":item.note;
		let itemNewNote = (typeof item.newNote == "undefined")?"":item.newNote;
		
		return (item.note != item.newNote )?itemNewNote:itemNote;
		
	}

};

